$component-class: 'me-tagline';
$tagline-font-size: map-get($font-sizes, md);
$tagline-line-height: map-get($line-heights, md);
$tagline-font-weight: map-get($font-weights, semi-bold);
$tagline-margin-bottom: var(--spacing-md);

.#{$component-class} {
  font-size: $tagline-font-size;
  line-height: $tagline-line-height;
  font-weight: $tagline-font-weight;
  margin: 0 0 $tagline-margin-bottom;
}

#{$component-class}:last-child {
  .#{$component-class} {
    margin-bottom: 0;
  }
}

@mixin generate-align-classes {
  @each $align in $aligns {
    .#{$component-class}--#{$align} {
      text-align: $align;
    }
  }
}

@include generate-align-classes;
